"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../actions/");
const reducers_1 = require("../../reducers/");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../wizards/components/MobilePopover");
class NotificationStatisticsPopover extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentDetail: null,
            detailAnimation: 'ltr',
        };
        this.closeDetail = this.closeDetail.bind(this);
        this.getButtonLeft = this.getButtonLeft.bind(this);
        this.getPopoverId = this.getPopoverId.bind(this);
        this.setState = this.setState.bind(this);
    }
    closeDetail() {
        this.setState({ detailAnimation: 'rtl' }, () => setTimeout(() => this.setState({
            currentDetail: null,
            detailAnimation: 'ltr',
        }), 150));
    }
    getButtonLeft() {
        const { currentDetail } = this.state;
        if (currentDetail === null) {
            return null;
        }
        return (React.createElement("div", { style: {
                display: 'flex',
                marginLeft: 16,
            }, onClick: this.closeDetail },
            React.createElement(src_1.ChevronLeftIcon, { fill: "#000" }),
            React.createElement(src_1.Button, { text: "Back", type: "disabled", style: {
                    innerStyle: {
                        fontSize: 17,
                        padding: 0,
                        color: src_1.steel,
                    },
                    outerStyle: {
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                    },
                } })));
    }
    getMobilePopover() {
        const { closePopoverModalForm, isPopoverModalFormOpen, label, updateActivePopover } = this.props;
        const { currentDetail } = this.state;
        return ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                customLeftElem: this.getButtonLeft(),
                title: currentDetail || label,
                buttonLeftCallback: () => {
                    closePopoverModalForm();
                    setTimeout(() => updateActivePopover(''), 500);
                },
            } },
            React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                } }, this.renderStats())), document.getElementById('mainModalLeft'));
    }
    getPopoverId() {
        const { popoverId } = this.props;
        return `notification-statistic-${popoverId}`;
    }
    renderStats() {
        const { currentDetail, detailAnimation } = this.state;
        const { children, device } = this.props;
        return (React.createElement("div", { style: { overflowX: 'hidden' } },
            currentDetail && (React.createElement("div", { style: { position: 'relative' } },
                React.createElement("div", { style: {
                        height: children.length * 81 - 1,
                        width: '100%',
                        backgroundColor: 'white',
                        animation: `${detailAnimation} 150ms ease-in-out`,
                        position: 'absolute',
                        padding: 24,
                    } },
                    React.createElement(src_1.Text, { size: "small", text: children.filter((child) => child.props.name === currentDetail)[0].props.detail })))),
            React.createElement(src_1.SelectableList, { device: device }, children.map((child, index) => React.cloneElement(child, {
                key: index,
                onClick: () => this.setState({
                    currentDetail: child.props.name,
                }),
            })))));
    }
    render() {
        const { activator, activePopover, device, label, updateActivePopover } = this.props;
        const { currentDetail } = this.state;
        if (device === 'Mobile') {
            return React.createElement(React.Fragment, null, activePopover === this.getPopoverId() && this.getMobilePopover());
        }
        return (React.createElement(src_1.PopoverContainer, { id: this.getPopoverId(), onClick: () => activePopover === this.getPopoverId()
                ? updateActivePopover('')
                : updateActivePopover(this.getPopoverId()), popoverProps: {
                placement: 'left',
                device: device,
                navBarProperties: {
                    customLeftElem: this.getButtonLeft(),
                    title: currentDetail || label,
                    id: 'notification-statistics-popover-navbar',
                },
                arrowColors: {
                    primary: src_1.cloud,
                    secondary: src_1.white,
                    border: src_1.titanium,
                },
                overlayClickHandler: () => this.setState({
                    currentDetail: null,
                    detailAnimation: 'ltr',
                }),
            }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', showPopover: activePopover === this.getPopoverId() },
            activator,
            React.createElement(React.Fragment, null, this.renderStats())));
    }
}
const mapStateToProps = (state, ownProps) => {
    const { campaignId } = ownProps;
    return {
        activePopover: reducers_1.getActivePopover(state),
        campaign: reducers_1.getCampaign(state, campaignId),
        isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    };
};
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (activePopover) => {
        return dispatch(actions_1.updateActivePopover(activePopover));
    },
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NotificationStatisticsPopover);
